module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_8003.d7d6c396.png";